export function stack(cutOf = 1): string | null {
    const trace = Error().stack;
    return trace?.split('\n').splice(0, cutOf).join('\n') ?? null;
}
